"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailoverRpcProvider = void 0;
var providers_1 = require("@near-js/providers");
Object.defineProperty(exports, "FailoverRpcProvider", { enumerable: true, get: function () { return providers_1.FailoverRpcProvider; } });
